import React, { useEffect } from "react";

export default function Toast({ message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="
      fixed bottom-6 left-1/2 -translate-x-1/2
      bg-white/50 backdrop-blur-xl border border-white/30
      px-6 py-3 rounded-xl shadow-xl text-gray-800
      animate-fadeIn z-50
    ">
      {message}
    </div>
  );
}
